import React from "react";
import "./customtextfield.css";

const CustomTextField = ({
  clsNames = "",
  styles = {},
  placeholder = "",
  placeHolder = "", // For backward compatibility
  id = "default-text-field",
  required = false,
  value = undefined,
  handleOnChange = (e) => console.log(id + " - " + e.target.value),
  onChange = null,
  disabled = false,
}) => {
  // Use onChange if provided, otherwise fall back to handleOnChange
  const onChangeHandler = onChange || handleOnChange;

  // Use placeholder prop, fall back to placeHolder for backward compatibility
  const displayPlaceholder = placeholder || placeHolder;

  // If value is undefined, this will be an uncontrolled component
  // If value has a defined value (including empty string), it will be controlled
  const inputProps = value !== undefined ? { value } : {};

  return (
    <div className={clsNames}>
      <input
        type="text"
        required={required}
        id={id}
        placeholder={displayPlaceholder}
        onChange={onChangeHandler}
        {...inputProps}
        className={`custom-text-field ${clsNames}`}
        style={styles}
        disabled={disabled}
      />
    </div>
  );
};

export default React.memo(CustomTextField);
